import React, { useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Layout.css';

/**
 * Navigation labels and destinations are unchanged from the original site.
 * @author Nelson
 */
const NAV_ITEMS = [
    { to: '/', label: 'Home', end: true },
    { to: '/aboutus', label: 'About' },
    { to: '/support/service', label: 'Support' },
    { to: '/our/apps', label: 'Our App' },
    { to: '/privacy', label: 'Privacy' }
];

const BASE_TITLE = 'Yuan Lab Enterprise';

/**
 * Shared shell: ambient ground, sticky navigation, page slot, footer.
 * Every page renders through this so the site reads as one system.
 */
const Layout = ({ children, title, nav = true, pad = 'default' }) => {
    useEffect(() => {
        document.title = title ? `${title} — ${BASE_TITLE}` : BASE_TITLE;
    }, [title]);

    return (
        <div className="shell">
            <div className="shell__ground" aria-hidden="true">
                <span className="shell__aura shell__aura--a" />
                <span className="shell__aura shell__aura--b" />
                <span className="shell__grid" />
            </div>

            {nav && (
                <header className="nav">
                    <div className="nav__inner">
                        <Link to="/" className="brand" aria-label="YUAN Lab Enterprise — home">
                            <img
                                className="brand__mark"
                                src="/logo-mark-96.png"
                                width="30"
                                height="30"
                                alt=""
                            />
                        </Link>

                        <nav className="nav__links" aria-label="Primary">
                            {NAV_ITEMS.map((item) => (
                                <NavLink
                                    key={item.to}
                                    to={item.to}
                                    end={item.end}
                                    className={({ isActive }) =>
                                        isActive ? 'navlink navlink--active' : 'navlink'
                                    }
                                >
                                    {item.label}
                                </NavLink>
                            ))}
                        </nav>
                    </div>
                </header>
            )}

            <main className={pad === 'default' ? 'main' : `main main--${pad}`}>{children}</main>

            <footer className="foot">
                <div className="foot__inner">
                    <img
                        className="foot__mark"
                        src="/logo-mark-96.png"
                        width="26"
                        height="26"
                        alt=""
                    />
                    <p className="foot__copy">&copy; 2025 YUAN Lab Enterprise. All rights reserved.</p>
                    <p className="foot__meta">
                        Business Registration No: <strong>JM1023116-P</strong><br />
                        Address: Bukit Mertajam, Penang, Malaysia<br />
                        Registered in Malaysia.
                    </p>
                </div>
            </footer>
        </div>
    );
};

export default Layout;
